const state = {
  tenantId: "-1",
  currentTenantId: "",
  tenantName: "",
  tenantCode: ""
};

const getters = {};

const actions = {
  actionTenantId({ commit, state }, tenantId) {
    commit("mutationTenantId", tenantId);
  },
  actionCurrentTenantId({ commit, state }, tenantId) {
    commit("mutationCurrentTenantId", tenantId);
  },
  actionTenantName({ commit, state }, tenantName) {
    commit("mutationTenantName", tenantName);
  },
  actionTenantCode({ commit, state }, tenantCode) {
    commit("mutationTenantCode", tenantCode);
  }
};

const mutations = {
  mutationTenantId(state, tenantId) {
    state.tenantId = tenantId;
  },
  mutationCurrentTenantId(state, tenantId) {
    state.currentTenantId = tenantId;
    sessionStorage.setItem("currentTenantId", tenantId)
  },
  mutationTenantName(state, tenantName) {
    state.tenantName = tenantName;
    sessionStorage.setItem("tenantName", tenantName)
  },
  mutationTenantCode(state, tenantCode) {
    state.tenantCode = tenantCode;
    sessionStorage.setItem("tenantCode", tenantCode)
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
